import { NextPageWithLayout } from 'next';
import React, { ReactElement } from 'react';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { useIntl } from 'react-intl';
import markdown from '../data/staticPages/fashionweekweb.md';
import Layout from '../components/Layout';
import messages from '../lib/messages.json';
import LinkAndAnchor from '../components/LinkAndAnchor';
import HomeLink from '../components/HomeLink';
import Head from '../components/Head';
import Markdown from '../components/Markdown';

const FashionWeekWebPage: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="fashionweekweb"
      passHref
    >
      {intl.formatMessage(messages.fashionweekweb)}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages.fashionweekweb)}
        description={intl.formatMessage(messages.fashionweekweb)}
      />
      <StaticPageComponent
        content={<Markdown markdown={markdown} />}
        title={intl.formatMessage(messages.fashionweekweb)}
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

FashionWeekWebPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default FashionWeekWebPage;
